"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const helpers_1 = require("../../helpers");
const styles_1 = require("./styles");
const InputNumber = props => {
  const {
    onValueChange,
    value = 0,
    controls,
    dataAutomation = 'input-number',
    ...rest
  } = props;
  const {
    name = '',
    step = 1,
    max,
    min
  } = rest;
  const [internalValue, setInternalValue] = (0, react_1.useState)(value.toString());
  const onChange = e => {
    const {
      target: {
        value: rawValue
      }
    } = e;
    const newValue = rawValue.trim();
    const isValidNumber = (0, helpers_1.validateNumber)(newValue || 0);
    if (!isValidNumber) {
      return;
    }
    const numberValue = isValidNumber ? Number(newValue || 0) : value;
    setInternalValue(newValue);
    onValueChange(numberValue, name);
  };
  const handleStep = e => {
    const {
      currentTarget: {
        name: currentName
      }
    } = e;
    const newValue = currentName === 'up' ? (0, helpers_1.addNumbers)(value, step) : (0, helpers_1.addNumbers)(value, -step);
    if (min !== undefined && newValue < min) {
      onValueChange(min, name);
      return;
    }
    if (max !== undefined && newValue > max) {
      onValueChange(max, name);
      return;
    }
    onValueChange(newValue, name);
  };
  const onBlur = () => {
    if (min !== undefined && value < min) {
      onValueChange(min, name);
      return;
    }
    if (max !== undefined && value > max) {
      onValueChange(max, name);
      return;
    }
  };
  (0, react_1.useEffect)(() => {
    setInternalValue(value.toString());
  }, [value]);
  return (0, jsx_runtime_1.jsxs)(styles_1.InputContainer, {
    children: [(0, jsx_runtime_1.jsx)(styles_1.StyledInput, {
      ...rest,
      value: internalValue,
      onChange: onChange,
      onBlur: onBlur,
      "data-automation": dataAutomation
    }), controls && (0, jsx_runtime_1.jsxs)(styles_1.ButtonsContainer, {
      children: [(0, jsx_runtime_1.jsx)(styles_1.ControlButton, {
        isIncrement: true,
        name: "up",
        onClick: handleStep
      }), (0, jsx_runtime_1.jsx)(styles_1.ControlButton, {
        name: "down",
        onClick: handleStep
      })]
    })]
  });
};
exports.default = InputNumber;